import React from 'react'
import { Link } from 'gatsby'

import logo from '../assets/images/nav-logo.png'
import config from '../utils/config'
import { favoritePosts } from '../../content/data/favorite-posts'

export const Sidebar = ({ theme }) => {
  return (
    <aside className="sidebar">
      <div className="sidebar-wrapper">
        <div className="sidebar-title">
          <Link to="/" className="sidebar-title-link">
            <span>
              <img
                src={logo}
                className="sidebar-logo"
                alt="Sidebar Logo"
                title={config.title}
              />
            </span>
            <span>{config.author}</span>
          </Link>
        </div>
        <div className="sidebar-container">
          <section className="sidebar-section">
            <h2>About Me</h2>
            <div className="sidebar-content">
              <p>
                I'm <Link to="/me">Alvri</Link>, a software engineer. Welcome to
                my space 🚀
              </p>

              <p>
                <img
                  src={'https://listen-to-spotify.membasuh.com/?theme=' + theme}
                  alt="Listen to Music"
                  title="🎶 Listen to Music"
                  width="100%"
                  height="100%"
                />
              </p>
            </div>
          </section>

          <section className="sidebar-section">
            <h2>Stay in Touch</h2>
            <p>Here's how to keep up with me:</p>
            <p>
              📚{' '}
              <a href="/rss.xml" target="_blank" rel="noopener noreferrer">
                RSS Feed
              </a>
              <br />
              🔗{' '}
              <a
                href="https://linkedin.com/in/azisalvriyanto"
                target="_blank"
                rel="noopener noreferrer"
              >
                LinkedIn
              </a>
              <br />
              ✍🏼{' '}
              <a
                href="https://azisalvriyanto.medium.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                Medium
              </a>
            </p>
            <p>
              Feel free to view 📑{' '}
              <a
                href="https://resume.azisalvriyanto.membasuh.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                my resume
              </a>
              {'.'}
            </p>
          </section>

          {favoritePosts.length > 0 && (
            <section className="sidebar-section">
              <h2>Favorites</h2>
              <nav className="sidebar-menu">
                {favoritePosts.map((link) => (
                  <Link key={link.url} to={link.url}>
                    {link.title}
                  </Link>
                ))}
              </nav>
            </section>
          )}
        </div>
      </div>
    </aside>
  )
}
